import { useDroppable } from '@dnd-kit/core';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { encodeInsertId } from '@/components/tree-dnd/tree-dnd-path';
import { useTreeDndDropIndicator } from '@/components/tree-dnd/tree-dnd-context';
import { isDropIndicatorAt } from '@/components/tree-dnd/tree-dnd-drop-indicator';
import { cn } from '@/lib/utils';

interface TreeDndDropLineProps {
  parentPath: NodePath;
  index: number;
}

export function TreeDndDropLine({ parentPath, index }: TreeDndDropLineProps) {
  const dropIndicator = useTreeDndDropIndicator();
  const isActive = isDropIndicatorAt(dropIndicator, parentPath, index);

  const { setNodeRef } = useDroppable({
    id: encodeInsertId(parentPath, index),
  });

  return (
    <div
      ref={setNodeRef}
      className={cn('flex h-3 shrink-0 items-center', isActive && 'py-0.5')}
    >
      {isActive ? (
        <div className="h-1.5 w-full rounded-full bg-blue-500" />
      ) : null}
    </div>
  );
}
